"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildResolutionFromReview = buildResolutionFromReview;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const signal_id_orphan_pruning_1 = require("../../DataScience/signal-hygiene/signal-id-orphan-pruning");
const package_store_package_resolution_1 = require("../../PackageStore/package-store-package-resolution");
const signal_tie_transforms_1 = require("../../SignalTies/signal-tie-transforms");
const package_resolution_codecs_1 = require("./package-resolution-codecs");
function selectWrittenFields(view, writeFields) {
    if (writeFields === undefined) {
        return view;
    }
    const selected = {};
    for (const field of writeFields) {
        selected[field] = view[field];
    }
    return selected;
}
function buildResolutionFromReview(payload, opts) {
    const view = (0, package_resolution_codecs_1.applyPayloadToResolution)(payload);
    const written = selectWrittenFields({
        ...view,
        signals: (0, signal_tie_transforms_1.normalizeSignalTies)(view.signals),
    }, opts?.writeFields);
    const assembled = {
        ...(opts?.base ?? (0, package_store_package_resolution_1.createDefaultPackageResolution)()),
        ...written,
    };
    const signalPruned = pruneDeadSignalReferences(assembled, opts?.onOrphan);
    if (opts?.modeProvenance === 'authored') {
        return signalPruned;
    }
    return pruneDeadModeReferences(signalPruned, opts?.onOrphan);
}
function pruneDeadSignalReferences(resolution, onOrphan) {
    const signalIds = new Set(resolution.signals.map((signal) => String(signal.id)));
    const reporterFor = (field) => onOrphan ? (orphanId, fieldPath) => onOrphan(field, orphanId, fieldPath) : undefined;
    return {
        ...resolution,
        signals: (0, signal_id_orphan_pruning_1.pruneTieOrphans)(resolution.signals, signalIds, reporterFor('ties')),
        pins: (0, signal_id_orphan_pruning_1.prunePinOrphans)(resolution.pins, signalIds, reporterFor('pins')),
        boundaries: (0, signal_id_orphan_pruning_1.pruneBoundaryOrphans)(resolution.boundaries, signalIds, reporterFor('boundaries')),
        spiceModels: (0, signal_id_orphan_pruning_1.pruneSpiceModelOrphans)(resolution.spiceModels, signalIds, reporterFor('spiceModels')),
    };
}
function pruneDeadModeReferences(resolution, onOrphan) {
    const keptModes = (0, sigma_engine_shared_1.filterModesToReferencedOnly)(resolution.modes, resolution.signals, resolution.boundaries);
    if (onOrphan !== undefined) {
        const keptIds = new Set(keptModes.map((mode) => mode.id));
        for (const mode of resolution.modes) {
            if (!keptIds.has(mode.id)) {
                onOrphan('modes', mode.id, 'unreferenced');
            }
        }
    }
    return { ...resolution, modes: keptModes };
}
//# sourceMappingURL=resolution-builder.js.map